import {
    GET_NOTES_SUCCESS,
    SAVE_NOTE,
    DELETE_NOTE,
    GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD,
    GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL,
} from "../constant";

const initial = {
    customers: [],
    getCustomerErr: false
};

export const userSubscriptionsReducer = (state = initial, action) => {
    switch (action.type) {
        case GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD:
            let customersToInsert = state.customers
            if(!state.customers.find(c => c.customerId == action.payload.customerId)){
                customersToInsert = [...customersToInsert, action.payload]
            }else {
                const currentCustomerIndex = state.customers.findIndex(c => c.customerId == action.payload.customerId)
                customersToInsert[currentCustomerIndex] = action.payload
            }
            return {
                ...state,
                customers: customersToInsert
            }
        case GET_CUSTOMER_SUBSCRIPTION_DETAILS_AD_FAIL:
            return {
                ...state,
                getCustomerErr: action.payload
            }
        default:
            return state;
    }
};